var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.168 26V16.748H0.36V14.444H3.168V11.492H0.36V9.188H3.168V0.295998H6.912L10.332 9.188H14.58V0.295998H17.424V9.188H20.232V11.492H17.424V14.444H20.232V16.748H17.424V26H13.644L10.224 16.748H5.976V26H3.168ZM5.976 14.444H9.36L8.28 11.492H5.904L5.976 14.444ZM14.58 20.924H14.724L14.616 16.748H13.104L14.58 20.924ZM5.904 9.188H7.416L5.904 4.724H5.76L5.904 9.188ZM12.24 14.444H14.652L14.58 11.492H11.16L12.24 14.444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.cd05de0c6c267f1c6d97a1e78382152c.svg";
export { ForwardRef as ReactComponent };